import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_UTILITY_PARTNER_GET_STRIPE_ACCOUNTS } from 'api/utilityActionTypes';

export default async function getStripeAccounts(
  { state, utilityApiClient },
  { slug, forceRefresh = false },
) {
  typeCheck('slug::NonEmptyString', slug);

  const currentPartnerStatePath = ['utilityPartners', 'stripeAccountsByPartnerSlug', slug];

  if (state.get(currentPartnerStatePath) && !forceRefresh) {
    return state.get(currentPartnerStatePath);
  }

  return utilityApiClient.postWithState({
    action: SR_API_ACTION_UTILITY_PARTNER_GET_STRIPE_ACCOUNTS,
    queryId: slug,
    state: state,
    payload: {
      slug,
    },
    onSuccess(partnerStripeAccounts) {
      if (!partnerStripeAccounts) {
        return;
      }

      state.set(currentPartnerStatePath, partnerStripeAccounts);
    },
  });
}
